import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const Loader = ({ messageId }) => (
  <div className="fixed inset-0 z-[10000] grid place-items-center bg-[color-mix(in_srgb,var(--owner-page-bg)_78%,transparent)] backdrop-blur-sm">
    <div className="flex flex-col items-center gap-3">
      <span
        aria-label="Loading"
        className="inline-block h-10 w-10 animate-spin rounded-full border-2 border-[var(--owner-border)] border-t-[var(--tenant-primary)]"
        role="status"
      />
      <p className="text-sm text-[var(--owner-text-muted)]">
        <FormattedMessage id={messageId} />
      </p>
    </div>
  </div>
);

Loader.propTypes = {
  messageId: PropTypes.string,
};

Loader.defaultProps = {
  messageId: 'general.loading',
};

export default Loader;
